module.exports = __webpack_public_path__ + "media/images/ow-bonus-kv@3x-f3192c25c35abaec50309b1afafeff0e.png";